var React = require('react');

function CheeseSwiss (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M299.83 32C418 38.22 512 136.13 512 256H0l141.84-110.44a47.91 47.91 0 0 0 75.1-58.48L278.7 39a32 32 0 0 1 21.13-7z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 288a48 48 0 0 1-96 0H0v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM176 432a48 48 0 1 1 48-48 48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

CheeseSwiss.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CheeseSwiss;

CheeseSwiss.default = CheeseSwiss;
